module.exports = __webpack_public_path__ + "media/images/pc/brands/an/store_an-1b746e553ac8a40a9ccd48deafb9ce7e.jpg";